export class AppointmentRoutingRouteNames {
    public static readonly MakeAppointment = 'make';
    public static readonly ForVet = 'vet';
    public static readonly VetIdParam = 'vetId';
    public static readonly ForExternalVetId = 'eVet';
    public static readonly Process = 'process';
    public static readonly AppointmentProcessOutlet = 'outlet-appointment-process';
    public static readonly ProcessRoutes = {
        AnimalSelection: 'animal-selection',
        VetSelection: 'vet-selection',
        VetVicinity: 'vet-vicinity',
        DateSelection: 'date-selection',
        DataOverview: 'data-overview',
        Summary: 'summary',
        AppointmentBookRequest: 'appointment-book-request',
        Success: 'success',
    };
}
